import { roundNumber } from '@pkg/utils';

const baseHeight = 40;
const symbolSize = 28;

function em(value = 0) {
    // In order to satisfy the various different "headers",
    // each with different CTA sizes, this component has
    // been built to size all UI relative to the `baseHeight`.
    return roundNumber(value / baseHeight, 2);
}

export const tokens = {
    baseHeight,
    action: {
        gap: em(8),
        padding: em((baseHeight - symbolSize) / 2),
        minWidth: em(144),
        bgColor: {
            base: '#121212',
            hover: '#1f1f1f',
        },
        borderColor: {
            base: '#353535',
            hover: '#474747',
        },
    },
    symbol: {
        size: em(symbolSize),
        iconSize: em(18),
    },
    details: {
        gap: em(2),
    },
    label: {
        fontSize: em(10),
    },
    name: {
        fontSize: em(14),
    },
    arrow: {
        size: em(10),
    },
    popover: {
        // This value is passed to `floating-ui`, so it has to remain a `px` value.
        offset: 10,
    },
    menu: {
        radius: em(10),
        list: {
            gap: em(2),
            padding: em(4),
        },
        option: {
            gap: em(8),
            radius: em(6),
            padding: {
                x: em(8),
                y: em(4),
            },
        },
        symbol: {
            size: em(20),
            iconSize: em(12),
        },
    },
};
